module.exports = __webpack_public_path__ + "img/bgc.39a54fd3.png";